import { render, staticRenderFns } from "./ModalErroProcessamentoVerificacao.vue?vue&type=template&id=5a106a1e&lang=pug"
import script from "./ModalErroProcessamentoVerificacao.vue?vue&type=script&lang=js"
export * from "./ModalErroProcessamentoVerificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalErroProcessamentoVerificacao.vue?vue&type=style&index=0&id=5a106a1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports